export const primaryColor = 'rgb(78, 18, 197)'
export const secondaryColor = 'rgb(137, 197, 18)'

export const messageBackgroundColor = 'rgba(137, 197, 18, 0.7)'

export const standardBorderRadius = '8px'
export const backgroundTransparent = 'rgba(78, 18, 197, 0.03)'


export const textBoxBorderColor = "rgba(0, 0, 0, 0.23)" // same as mui
export const textBoxHorizontalPadding = '14px' // same as mui
export const textBoxVerticalPadding = '16.5px' // same as mui
export const textBoxBorderRadius = '4px' // same as mui
export const textBoxColor = "rgba(0, 0, 0, 0.60)"
